var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white relative mt-20"},[_c('Futurefit'),_c('Companies'),_c('Numbercards'),_c('SwiperCard'),_c('Wehelp'),_c('Tranformative'),_c('Corporatehub'),_c('Support'),_c('Ourpartners'),_c('Testimonial1'),_c('Contactusfinal'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }